var ___EXPOSE_LOADER_IMPORT___ = require("-!../node_modules/swc-loader/src/index.js??ruleSet[1].rules[2].use[0]!../config/conditional_loader.js!./index.js");
var ___EXPOSE_LOADER_GET_GLOBAL_THIS___ = require("../node_modules/expose-loader/dist/runtime/getGlobalThis.js");
var ___EXPOSE_LOADER_GLOBAL_THIS___ = ___EXPOSE_LOADER_GET_GLOBAL_THIS___;
if (typeof ___EXPOSE_LOADER_GLOBAL_THIS___["vl"] === 'undefined') ___EXPOSE_LOADER_GLOBAL_THIS___["vl"] = ___EXPOSE_LOADER_IMPORT___;
module.exports = ___EXPOSE_LOADER_IMPORT___;
